import { COMPOSED_CLAIMS } from 'constants/composedClaims';
import { PAGE_CODES } from 'constants/pageCodes';

export const ClaimValue = {
  NONE: 'none',
  VIEW: 'view',
  EDIT: 'edit',
  MANAGE: 'manage',
  ACCESS: 'access',
};

export const PageCodeComparisonType = {
  AND: 'and',
  OR: 'or',
};

export const PageCodeComparisonMethod = {
  [PageCodeComparisonType.AND]: 'every',
  [PageCodeComparisonType.OR]: 'some',
};

// Page codes whose value is itself an ATOMIC granted claim (no .view/.manage/.edit/.access
// suffix), so the guard must match the claim string verbatim instead of appending a suffix.
// COMMAND_CENTER_MANAGE_ANNOUNCEMENTS resolves to the backend claim "commandCenter.manageAnnouncements"
// — the single value Skynet.Loans gates announcement authoring on (CommandCenterAnnouncementsClaims.Manage),
// seeded to internal.Admin. It is NOT a "commandCenter" page-code with a ".manageAnnouncements" suffix,
// so suffix-appending the standard verbs never matches the granted claim and 403s every holder.
export const BARE_CLAIM_PAGE_CODES = new Set([PAGE_CODES.COMMAND_CENTER_MANAGE_ANNOUNCEMENTS]);

export const DISABLED_CLAIMS_BY_OTHER_CLAIMS = {
  [`${PAGE_CODES.LOCK_EXTENSIONS}.${ClaimValue.NONE}`]: [COMPOSED_CLAIMS.LOCK_EXTENSIONS_OVERRIDE],
  [`${PAGE_CODES.LOCK_EXTENSIONS}.${ClaimValue.VIEW}`]: [COMPOSED_CLAIMS.LOCK_EXTENSIONS_OVERRIDE],

  [`${PAGE_CODES.LOAN_APPLICATION}.${ClaimValue.NONE}`]: [
    COMPOSED_CLAIMS.LOAN_APPLICATION_CHANGE_PROGRAM,
    COMPOSED_CLAIMS.LOAN_APPLICATION_SAVE_WITHOUT_PROGRAM,
    COMPOSED_CLAIMS.LOAN_APPLICATION_SWITCH_AUS_TYPE,
    COMPOSED_CLAIMS.LOAN_APPLICATION_EDIT_LEADS,
  ],
  [`${COMPOSED_CLAIMS.LOAN_APPLICATION_ACTIVITIES}.${ClaimValue.NONE}`]: [
    COMPOSED_CLAIMS.LOAN_APPLICATION_CALLS,
    COMPOSED_CLAIMS.LOAN_APPLICATION_CHAT,
  ],
  [`${PAGE_CODES.LOAN_APPLICATION}.${ClaimValue.VIEW}`]: [
    COMPOSED_CLAIMS.LOAN_APPLICATION_CHANGE_PROGRAM,
    COMPOSED_CLAIMS.LOAN_APPLICATION_SAVE_WITHOUT_PROGRAM,
    COMPOSED_CLAIMS.LOAN_APPLICATION_SWITCH_AUS_TYPE,
  ],

  [`${PAGE_CODES.TASKS}.${ClaimValue.NONE}`]: [
    COMPOSED_CLAIMS.APPROVE_REJECT_CANCEL_TASK,
    COMPOSED_CLAIMS.UPDATE_STATUS_TASK,
  ],

  [`${PAGE_CODES.WAREHOUSE_BANKS}.${ClaimValue.VIEW}`]: [
    `${PAGE_CODES.WAREHOUSE_BANK_LINE_MANAGEMENT}.${ClaimValue.NONE}`,
  ],
  [`${PAGE_CODES.WAREHOUSE_BANKS}.${ClaimValue.EDIT}`]: [
    `${PAGE_CODES.WAREHOUSE_BANK_LINE_MANAGEMENT}.${ClaimValue.NONE}`,
  ],
  [`${PAGE_CODES.WAREHOUSE_BANKS}.${ClaimValue.MANAGE}`]: [
    `${PAGE_CODES.WAREHOUSE_BANK_LINE_MANAGEMENT}.${ClaimValue.NONE}`,
  ],
};

export const ClaimLevel = [ClaimValue.NONE, ClaimValue.VIEW, ClaimValue.EDIT, ClaimValue.MANAGE];

export const DEPENDENT_CLAIMS_DEFAULT_VALUE = {
  [`${PAGE_CODES.LOAN_APPLICATION}.${ClaimValue.EDIT}`]: {
    [COMPOSED_CLAIMS.LOAN_APPLICATION_CHANGE_PROGRAM]: true,
  },
};

// Approve/Reject/Cancel is a superset of Update Status, so checking the former must also
// check the latter (unlike DEPENDENT_CLAIMS_DEFAULT_VALUE above, this is keyed by a CHECKBOX
// claim name rather than a radio group's page-code value, and only auto-checks — it never
// force-unchecks a dependent claim, since the two remain independently assignable).
export const CHECKBOX_DEPENDENT_CLAIMS = {
  [COMPOSED_CLAIMS.APPROVE_REJECT_CANCEL_TASK]: [COMPOSED_CLAIMS.UPDATE_STATUS_TASK],
};

export const WAREHOUSE_LINE_DISABLED_CLAIM_TOOLTIP = {
  [`${PAGE_CODES.WAREHOUSE_BANK_LINE_MANAGEMENT}.${ClaimValue.NONE}`]:
    'Required when Warehouse banks is at least View.',
};

export const CLAIM_DEPENDENCIES = [
  {
    dependent: PAGE_CODES.WAREHOUSE_BANKS,
    prerequisite: PAGE_CODES.WAREHOUSE_BANK_LINE_MANAGEMENT,
    minLevel: ClaimValue.VIEW,
  },
];
